import api from './api'
import { ExerciseType } from 'store/services/Exercise'

export const trackExerciseActivity = (exerciseId: string, exerciseType: ExerciseType, bookId?: string) =>
  api.post('/activity', {
    exerciseId,
    exerciseType,
    bookId
  })

export const exerciseScore = (score: number, type: ExerciseType, word?: string) =>
  api.post('/exercise-score', {
    score,
    type,
    word
  })
